import { copyToClipboard } from '@veracity/ui-utils'
import { Box, useToast } from '@veracity/vui'

import { PageContainer, UserAdministrationPageMenu } from '@/components'
import { UserAdministrationSection } from '@/interfaces'

import {
  ApiManagementHeroSection,
  ApiManagementOtherDnvSection
} from './components'
import { useHeroApiKey, useOtherDnvApiKeys } from './hooks'

export const ApiManagementPage = () => {
  const { showInfo } = useToast()
  const { heroApiKeyInfo, reactivateHeroApiKey } = useHeroApiKey()
  const { otherDnvApiKeys } = useOtherDnvApiKeys()

  const handleCopyHeroApiKey = async () => {
    await copyToClipboard(heroApiKeyInfo?.key || '')
    showInfo('HERO API Key successfully copied.')
  }

  const handleCopyOtherApiKey = async (apiKey?: string) => {
    if (!apiKey) return
    await copyToClipboard(apiKey)
    showInfo('Api Key successfully copied')
  }

  return (
    <PageContainer
      header={
        <PageContainer.Breadcrumbs items={[{ title: 'Api Key Management' }]} />
      }
      menuBar={
        <UserAdministrationPageMenu
          activeSection={UserAdministrationSection.API_KEY_MANAGEMENT}
        />
      }>
      <Box column gap={2}>
        <ApiManagementHeroSection
          value={heroApiKeyInfo}
          onCopyKeyClicked={handleCopyHeroApiKey}
          onRegenerateClicked={reactivateHeroApiKey}
        />

        <ApiManagementOtherDnvSection
          externalApiKeys={otherDnvApiKeys}
          onCopyClicked={handleCopyOtherApiKey}
        />
      </Box>
    </PageContainer>
  )
}
